import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DevexModuleModule } from '../devex-module.module';
import { SpinnerOverlayComponent } from './common/spinner-overlay/spinner-overlay.component';
import { ConfirmContinueComponent } from './common/confirm-continue/confirm-continue.component';
import { CleCoursesListComponent } from './cle-courses-list/cle-courses-list.component';
import { CleSummaryTableComponent } from './cle-summary-table/cle-summary-table.component';


@NgModule({
  declarations: [
    SpinnerOverlayComponent,
    ConfirmContinueComponent,
    CleCoursesListComponent,
    CleSummaryTableComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DevexModuleModule
  ],
  exports: [
    SpinnerOverlayComponent,
    CleCoursesListComponent,
    CleSummaryTableComponent
  ]
})
export class ComponentsModule { }
